// Yeni Ekip Oluştur / Ekip Düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'tasks.createTeam';

export const createTeamGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ekip nasıl oluşturulur?'),
  intro: t(`${G}.intro`, 'Personellerinizi bir ekipte toplar, her birine ekipteki görevini ve rolünü verirsiniz. Ekip, proje (ekip görevi) oluştururken seçilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Ekip bilgileri ve üye tablosu'),
    footer: t(`${G}.regions.footer`, 'İptal / Ekibi Oluştur'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Ekip adını yazın'),
      text: t(`${G}.s1.text`, '"Ekip Adı" zorunludur (ör. Satış Ekibi, Proje Ekibi). "Ekip Açıklaması" isteğe bağlıdır; ekibin ne amaçla kurulduğunu yazabilirsiniz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Ekip rengini seçin'),
      text: t(`${G}.s2.text`, 'Renk dairelerinden birine tıklayın; yandaki simge seçtiğiniz renge döner. Renk, ekibi listelerde kolay ayırt etmenizi sağlar.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Üyeleri seçin'),
      text: t(`${G}.s3.text`, '"Ekip Üyeleri" kutusuna personel adını yazıp listeden işaretleyin; birden fazla kişi seçebilirsiniz. Seçilen her kişi alttaki "Ekip Üyeleri ve Görevleri" tablosuna eklenir. En az bir üye gerekir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Seçilen personel sayısı tablonun üstünde görünür.'),
        t(`${G}.s3.tip2`, 'Bir üyeyi çıkarmak için tablodaki çöp kutusuna basın veya seçim kutusundan işaretini kaldırın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Ekipteki görevi ve rolü girin'),
      text: t(`${G}.s4.text`, 'Tabloda her üye için "Ekipteki Görevi" alanını doldurun (ör. Saha sorumlusu); görevi boş olan üye varsa ekip kaydedilmez. "Rol" sütununda Lider, Görevli veya İzleyici seçin; yeni eklenen üye Görevli olarak gelir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Proje oluştururken görev atanacak üye listesinde kişinin adı ve ekipteki görevi birlikte görünür.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Ekibi Oluştur" yeni ekibi kaydeder; düzenlemede düğme "Güncelle" olur. Düzenlemede tablodan çıkardığınız üyeler ekipten silinir. "İptal" değişiklikleri kaydetmeden kapatır.'),
    },
  ],
});
